// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__-9eVi","projectme":"Projects_projectme__2gR0j"};